import React from 'react';
import styles from './Table.module.scss';
import cn from 'classnames';

const Table = (props) => (
  <table className={cn(props.className, styles.table)}>{props.children}</table>
);

export default Table;
